import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { PersonAddressType } from './person-address-type.interface';
import { PersonAddressTypeService } from './person-address-type.service';

const service = new PersonAddressTypeService();

export interface PersonAddressTypeState {
   personAddressTypes: Array<PersonAddressType>;
}

const PersonAddressTypeStore: Module<PersonAddressTypeState, StoreState> = {
   namespaced: true,
   state: {
      personAddressTypes: [],
   },
   getters: {},
   mutations: {
      SET_PERSON_ADDRESS_TYPES(state, personAddressTypes: Array<PersonAddressType>) {
         state.candidateAddressTypes = personAddressTypes;
      },
   },
   actions: {
      async getPersonAddressTypes(context, query?: LocationQuery) {
         const response = await service.getPersonAddressTypes(query);
         context.commit('SET_PERSON_ADDRESS_TYPES', response.data);
         return response.data;
      },
   },
};

export default PersonAddressTypeStore;
